// extracted by mini-css-extract-plugin
export default {"customDialog":"PFDialog_customDialog__OJkNQ"};